import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { CatalogModule } from './catalog/catalog.module';
import { CompareModule } from './compare/compare.module';
import { CartModule } from './cart/cart.module';
import { SignInComponent } from './signin.component';
import { SignUpComponent } from './signup.component';
import { PageNotFoundComponent } from './page-not-found.component';
import {
  SearchPageComponent,
  SearchPageResolver
} from './search-page.component';

import { HomePageComponent } from './home-page.component';
import {
  PersonalOrdersComponent,
  PersonalOrdersResolver
} from './personal-orders.component';
import { UserGuardService } from './user.service';
import {RegionsPageComponent} from './regions-page/regions-page.component';

const appRoutes: Routes = [
  {
    path: 'signin',
    component: SignInComponent,
    outlet: 'modal'
  },
  {
    path: 'signup',
    component: SignUpComponent,
    outlet: 'modal'
  },
  {
    path: 'personal-orders',
    component: PersonalOrdersComponent,
    resolve: {orders: PersonalOrdersResolver},
    canActivate: [UserGuardService]
  },
  {
    path: 'search',
    component: SearchPageComponent,
    resolve: {data: SearchPageResolver},
  },
  {
    path: 'catalog',
    loadChildren: () => import('./catalog/catalog.module').then(m => m.CatalogModule),
  },
  {
    path: 'compare',
    loadChildren: () => import('./compare/compare.module').then(m => m.CompareModule),
  },
  {
    path: 'cart',
    loadChildren: () => import('./cart/cart.module').then(m => m.CartModule),
  },
  {
    path: '',
    component: HomePageComponent,
  },
  {
    path: 'regions',
    pathMatch: 'full',
    component: RegionsPageComponent,
  },
  {
    path: 'regions/:id',
    component: HomePageComponent,
  },
  {
    path: 'regions/:id/catalog',
    loadChildren: () => import('./catalog/catalog.module').then(m => m.CatalogModule),
  },
  {
    path: '**',
    component: PageNotFoundComponent
  }
];

@NgModule({
  imports: [
    RouterModule.forRoot(appRoutes, {enableTracing: false})
  ],
  providers: [
    PersonalOrdersResolver,
    SearchPageResolver,
  ],
  exports: [
    RouterModule
  ]
})
export class RoutesModule {}
